import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import { api, formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.user?.role !== "admin") {
        toast.error("This portal is for administrators only.");
        setLoading(false);
        return;
      }
      await refresh();
      toast.success(`Welcome, ${data.user?.name || "admin"}`);
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicLayout>
      <section className="max-w-md mx-auto px-6 md:px-10 py-20" data-testid="admin-login-page">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-[var(--bb-forest)] text-white grid place-items-center">
            <ShieldCheck size={18}/>
          </div>
          <div className="bb-overline text-[var(--bb-muted)]">RESTRICTED · ADMIN PORTAL</div>
        </div>
        <h1 className="font-serif text-4xl md:text-5xl text-[var(--bb-forest)] tracking-tight leading-tight">Administrator access</h1>
        <p className="mt-4 text-[var(--bb-ink)]/75 text-sm">Authorised personnel only. Activities on this portal are audit-logged.</p>

        <form onSubmit={submit} className="mt-10 bb-card p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="bb-overline text-[var(--bb-muted)]">Email</label>
            <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} autoComplete="username" className="mt-2 w-full bg-transparent border-b border-[var(--bb-border)] py-2 outline-none focus:border-[var(--bb-terracotta)]" data-testid="admin-login-email"/>
          </div>
          <div>
            <label className="bb-overline text-[var(--bb-muted)]">Password</label>
            <input type="password" required value={password} onChange={e=>setPassword(e.target.value)} autoComplete="current-password" className="mt-2 w-full bg-transparent border-b border-[var(--bb-border)] py-2 outline-none focus:border-[var(--bb-terracotta)]" data-testid="admin-login-password"/>
          </div>
          <button type="submit" disabled={loading} className="bb-btn-primary w-full" data-testid="admin-login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-[10px] text-[var(--bb-muted)] text-center pt-1">Not an administrator? <a href="/login" className="bb-link">Use the regular sign-in</a>.</p>
        </form>
      </section>
    </PublicLayout>
  );
}
